<div class="modal" id="modal" >
    <input>
      <label>mecanico1</label>
      <label>mecanico2</label>
<div>